module.exports = __webpack_public_path__ + "img/mamtak_no.0df139d1.png";